import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import InputLabel from '@mui/material/InputLabel';
import { makeStyles } from '@mui/styles';
import Checkbox from '../Checkbox/Checkbox';

const useStyles = makeStyles((theme) => ({
	chips: {
		display: 'flex',
		flexWrap: 'wrap',
	},
	chip: {
		margin: theme.spacing(0.25),
	},
}));

const SelectField = (props) => {
	const { id, name, value, error = false, onChange, disabled, hintText, menuItems, isMultiSelect = false, customRenderValue, formControlStyle, ...rest } = props;
	const classes = useStyles();
	const [labelWidth, setLabelWidth] = useState(0);
	const InputLabelRef = useRef(undefined);
	useEffect(() => {
		setLabelWidth(InputLabelRef.current ? InputLabelRef.current.offsetWidth : 0);
	}, []);

	return (
		<FormControl error={error || false} fullWidth style={formControlStyle}>
			<InputLabel
				ref={ref => {
					InputLabelRef.current = ref;
				}}
				htmlFor={`${hintText}_selectField_input_id`}
				disabled={disabled || false}
			>
				{hintText}
			</InputLabel>
			<Select
				id={id}
				value={value}
				onChange={onChange}
				hintText={hintText}
				label={hintText}
				disabled={disabled || false}
				multiple={isMultiSelect}
				inputProps={{
					name,
					id: `${hintText}_selectField_input_id`,
				}}
				renderValue={isMultiSelect ? (selected) => {
					const selectedText = menuItems.filter((item) => selected.indexOf(item.value) !== -1);
					return selectedText.map(item => item.text).join(', ');
				} : false}
				{...rest}
			>
				{
					!isMultiSelect && menuItems.map((item, i) => (<MenuItem id={item.value} key={i} value={item.value} disabled={item.disabled}>{item.text}</MenuItem>))
				}
				{
					isMultiSelect && menuItems.map((item, i) => (
						<MenuItem id={item.value} key={i} value={item.value} disabled={item.disabled}>
							<Checkbox checked={value.indexOf(item.value) > -1} />
							{item.text}
						</MenuItem>
					))
				}
			</Select>
			{
				error && (
					<FormHelperText>{error}</FormHelperText>
				)
			}
		</FormControl>
	);
};

SelectField.propTypes = {
	id: PropTypes.string.isRequired,
	value: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number
	]),
	name: PropTypes.string,
	error: PropTypes.any,
	onChange: PropTypes.func.isRequired,
	disabled: PropTypes.bool,
	hintText: PropTypes.string.isRequired,
	menuItems: PropTypes.array.isRequired,
	classes: PropTypes.object,
	isMultiSelect: PropTypes.bool,
	customRenderValue: PropTypes.func,
	formControlStyle: PropTypes.object
};

export default SelectField;
